import { useToastContext } from "components/alert/ToastContext";
import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import ModalGerarNovasAuditorias from "components/modal/auditoria/ModalGerarNovasAuditorias";
import ModalSortearSetoresParaAuditoria from "components/modal/auditoria/ModalSortearSetoresParaAuditoria";
import ReportEdit from "components/reports/ReportEdit";
import saveAs from 'file-saver';
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import ContaParametroService from "service/administracao/cadastro/ContaParametroService";
import { converterDataHora } from "utils/convert";
import { booleanFilterTemplate, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, IdListMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, multiselectFilterTemplate, NumberMatchModeOptions, statusFilterTemplate } from "utils/filterUtils";

const auditoriaService = new AuditoriaService();
const usuarioLogadoService = new UsuarioLogadoService();
const contaParametroService = new ContaParametroService();

export default function AuditoriaListagem() {
    const [visibleDialogGerarNovaAuditoria, setVisibleDialogGerarNovaAuditoria] = useState(false);
    const [visibleDialogSortearSetores, setVisibleDialogSortearSetores] = useState(false);
    const listagemRef = useRef<BaseListagemRef>(null);

    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);
    const [setoresDisponiveis, setSetoresDisponiveis] = useState<Setor[]>([]);
    const [planos, setPlanos] = useState<PlanoAuditoria[]>([]);

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);

    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [editaRelatorioAuditoriaGeral, setEditaRelatorioAuditoriaGeral] = useState(false);
    const [editaRelatorioAuditoriaListagem, setEditaRelatorioAuditoriaListagem] = useState(false);
    const [editaRelatorioAuditoriaSimplificado, setEditaRelatorioAuditoriaSimplificado] = useState(false);
    const [editaRelatorioAuditoriaSimplificadoComImagens, setEditaRelatorioAuditoriaSimplificadoComImagens] = useState(false);
    const [editaRelatorioAuditoria, setEditaRelatorioAuditoria] = useState(false);
    const [editaRelatorioAuditoriaResultado, setEditaRelatorioAuditoriaResultado] = useState(false);
    const [exibeCampoTemNaoConformidade, setExibeCampoTemNaoConformidade] = useState(false);


    const { msgSucesso, msgErro } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const defaultFilters: DataTableFilterMeta = {
        numero: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        setor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        planoAuditoria: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        unidadeOrganizacional: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        auditor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: ['C', 'A'],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        temNaoConformidade: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const usuarioFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={usuarios} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const setorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={setoresDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_AUDITORIA_EDITAR"])) {
                setEditaRelatorioAuditoria(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_AUDITORIA_GERAL_EDITAR"])) {
                setEditaRelatorioAuditoriaGeral(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_AUDITORIA_LISTAGEM"])) {
                setEditaRelatorioAuditoriaListagem(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_AUDITORIA_SIMPLIFICADO_EDITAR"])) {
                setEditaRelatorioAuditoriaSimplificado(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_AUDITORIA_SIMPLIFICADO_COM_IMAGENS_EDITAR"])) {
                setEditaRelatorioAuditoriaSimplificadoComImagens(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_AUDITORIA_RESULTADO_EDITAR"])) {
                setEditaRelatorioAuditoriaResultado(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        auditoriaService.unidadesOrgan().then((resposta) => {
            setUnidades(resposta)
        }).catch((error) => {
            console.error("Erro ao buscar unidades organizacionais:", error);
        });
        contaParametroService.buscarParametro("AUDITORIA_EXIBIR_CAMPO_TEM_NAO_CONFORMIDADE").then((parametro) => {
            setExibeCampoTemNaoConformidade(Boolean(parametro?.valorBooleano));
        }).catch((erro) => {
            console.error("Erro ao buscar parâmetro de exibição de não conformidade:", erro);
        });

    }, []);

    useEffect(() => {
        const unidadeFilter = filters.unidadeOrganizacional as DataTableOperatorFilterMetaData;
        auditoriaService.getSetoresDisponiveis(unidadeFilter.constraints[0].value || undefined, unidadeFilter.constraints[0].matchMode==="equals").then(response => {
            setSetoresDisponiveis(response)
        }).catch(() => console.error("Erro ao buscar setores disponíveis"));
    }, [filters.unidadeOrganizacional]);

    useEffect(() => {
        const setorFilter = filters.setor as DataTableOperatorFilterMetaData;
        auditoriaService.getPlanosDisponiveis(setorFilter.constraints[0].value || undefined, setorFilter.constraints[0].matchMode==="equals").then(response => {
            setPlanos(response)
        }).catch(() => console.error("Erro ao buscar planos disponíveis"));

    }, [filters.setor]);

    useEffect(() => {
        auditoriaService.getUsuarios().then(response => setUsuarios(response)).catch(() => setUsuarios([]));
    }, []);


    function getButtonsExtra() {
        return [
            editaRelatorioAuditoria || editaRelatorioAuditoriaGeral
                || editaRelatorioAuditoriaListagem || editaRelatorioAuditoriaResultado
                || editaRelatorioAuditoriaSimplificado || editaRelatorioAuditoriaSimplificadoComImagens ? <SplitButton
                icon="pi pi-file-pdf"
                onClick={() => gerarRelatorioListagem()}
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorios(true)
                }]}
            /> : <Button
                type="button"
                icon="pi pi-file-pdf"
                onClick={() => gerarRelatorioListagem()}
            />,
            <Button
                style={{ marginLeft: 8 }}
                type="button"
                label="Sotear setores"
                onClick={() => {
                    setVisibleDialogSortearSetores(true);

                }}
            ></Button>,
            <Button
                style={{ marginLeft: 8 }}
                type="button"
                label="Gerar nova auditoria"
                onClick={() => {
                    setVisibleDialogGerarNovaAuditoria(true);

                }}
            ></Button>
        ]
    }

    function gerarRelatorioListagem() {
        startLoading();
        auditoriaService.getRelatorioListagem(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Auditorias.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    function testarRelatorio(nomeAcao: string) {
        auditoriaService.testarReport(nomeAcao).then(data => {
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, "testeRelatorio.pdf");
        }).catch(err => {
            console.log(err);
        });
    }

    return (
        <>
            {visibleDialogSortearSetores && <ModalSortearSetoresParaAuditoria
                visible={visibleDialogSortearSetores}
                onHide={() => {
                    setVisibleDialogSortearSetores(false);
                }}
                onConfirm={() => {
                    setVisibleDialogSortearSetores(false);
                    listagemRef.current?.reload();
                    msgSucesso("Sucesso", "Auditoria gerada com sucesso")
                }}
            />}
            <ModalGerarNovasAuditorias
                visible={visibleDialogGerarNovaAuditoria}
                onHide={() => {
                    setVisibleDialogGerarNovaAuditoria(false);
                }}
                onConfirm={() => {
                    setVisibleDialogGerarNovaAuditoria(false);
                    listagemRef.current?.reload();
                    msgSucesso("Sucesso", "Auditoria gerada com sucesso")
                }}
            />

            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                {editaRelatorioAuditoriaListagem ? <ReportEdit nomeAcao="RELATORIO_AUDITORIA_LISTAGEM" titulo="Relatório de listagem" testarRelatorio={() => testarRelatorio("RELATORIO_AUDITORIA_LISTAGEM")} style={{ marginBottom: 10 }} /> : null}
                {editaRelatorioAuditoria ? <ReportEdit nomeAcao="RELATORIO_AUDITORIA_EDITAR" titulo="Relatório para cada auditoria" testarRelatorio={() => testarRelatorio("RELATORIO_AUDITORIA_EDITAR")} style={{ marginBottom: 10 }} /> : null}
                {editaRelatorioAuditoriaSimplificadoComImagens ? <ReportEdit nomeAcao="RELATORIO_AUDITORIA_SIMPLIFICADO_COM_IMAGENS_EDITAR" titulo="Relatório Simplificado com Imagens" testarRelatorio={() => testarRelatorio("RELATORIO_AUDITORIA_SIMPLIFICADO_COM_IMAGENS_EDITAR")} /> : null}
                {editaRelatorioAuditoriaResultado ? <ReportEdit nomeAcao="RELATORIO_AUDITORIA_RESULTADO_EDITAR" titulo="Relatório Resultado da Auditoria" testarRelatorio={() => testarRelatorio("RELATORIO_AUDITORIA_RESULTADO_EDITAR")} /> : null}
                {editaRelatorioAuditoriaSimplificado ? <ReportEdit nomeAcao="RELATORIO_AUDITORIA_SIMPLIFICADO_EDITAR" titulo="Relatório simplificado" testarRelatorio={() => testarRelatorio("RELATORIO_AUDITORIA_SIMPLIFICADO_EDITAR")} style={{ marginBottom: 10 }} /> : null}
                {editaRelatorioAuditoriaGeral ? <ReportEdit nomeAcao="RELATORIO_AUDITORIA_GERAL_EDITAR" titulo="Relatório geral" testarRelatorio={() => testarRelatorio("RELATORIO_AUDITORIA_GERAL_EDITAR")} /> : null}

            </Dialog>

            <BaseListagem ref={listagemRef} ordenacao="nome,ASC" service={auditoriaService} urlService="/auditoria" tituloPagina={'Auditoria'}
                showNewButton={false}
                buttonsExtra={getButtonsExtra()}
                defaultFilters={defaultFilters} showClearFilterButton
                onChangeFilters={(filters) => setFilters(filters)}
                nome="auditoria"
            >
                <Column
                    field="numero" header="Nr."
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="setor.nome" header="Setor" filterField="setor"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={setorFilterTemplate}
                />
                <Column
                    field="planoAuditoria.nome" header="Plano de auditoria" filterField="planoAuditoria"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => multiselectFilterTemplate(options, planos)}
                />
                <Column field="dataGeracao" header="Dt. Geração" body={(rowData: Auditoria) => converterDataHora(rowData.dataGeracao)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataGeracao"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column field="unidadeOrganizacional.nome" header="Unid. Organ." filter filterField="unidadeOrganizacional" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, unidades)} />

                <Column
                    field="usuario.nome" header="Auditor" filterField="auditor"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={usuarioFilterTemplate}
                />
                <Column field="status" header="Status" filterField="status"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, auditoriaService.getStatusAuditoriaFilter())}
                    body={(rowData) => auditoriaService.getStatusAuditoria(rowData.status)}
                />
                {exibeCampoTemNaoConformidade && <Column
                    field="temNaoConformidade"
                    header="Tem NC"
                    body={(rowData: Auditoria) => rowData.temNaoConformidade ? "Sim" : "Não"}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Qualquer"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => booleanFilterTemplate(options)}
                />}
                <Column body={(rowData) => {
                    return <SplitButton
                        model={[
                            {
                                label: 'Simplificado', command: () => {
                                    startLoading();
                                    auditoriaService.getRelatorioSimplificado(rowData.id).then(data => {
                                        stopLoading();
                                        const file = new Blob([data], { type: 'application/pdf' });
                                        saveAs(file, `(simpl.) Auditoria ${rowData.setor.nome} - ${rowData.mes} - ${rowData.ano}.pdf`);
                                    }).catch(err => {
                                        stopLoading();
                                        msgErro("Erro ao gerar Relatório", err.message);
                                        console.log(err);
                                    });
                                }
                            },
                            {
                                label: 'Simplificado C/ Imagens', command: () => {
                                    startLoading();
                                    auditoriaService.getRelatorioSimplificadoComImagens(rowData.id).then(data => {
                                        stopLoading();
                                        const file = new Blob([data], { type: 'application/pdf' });
                                        saveAs(file, `(simplCImg.) Auditoria ${rowData.setor.nome} - ${rowData.mes} - ${rowData.ano}.pdf`);
                                    }).catch(err => {
                                        stopLoading();
                                        msgErro("Erro ao gerar Relatório", err.message);
                                        console.log(err);
                                    });
                                }
                            },
                            {
                                label: 'Resultado', command: () => {
                                    startLoading();
                                    auditoriaService.getRelatorioResultado(rowData.id).then(data => {
                                        stopLoading();
                                        const file = new Blob([data], { type: 'application/pdf' });
                                        saveAs(file, `(Res.) Auditoria ${rowData.setor.nome} - ${rowData.mes} - ${rowData.ano}.pdf`);
                                    }).catch(err => {
                                        stopLoading();
                                        msgErro("Erro ao gerar Relatório", err.message);
                                        console.log(err);
                                    });
                                }
                            }
                        ]}
                        icon="pi pi-file-pdf"
                        onClick={() => {
                            startLoading();
                            auditoriaService.getRelatorio(rowData.id).then(data => {
                                const file = new Blob([data], { type: 'application/pdf' });
                                saveAs(file, `Auditoria ${rowData.setor.nome} - ${rowData.mes} - ${rowData.ano}.pdf`);
                                stopLoading();
                            }).catch(err => {
                                stopLoading();
                                msgErro("Erro ao gerar Relatório", err.message);
                                console.log(err);
                            });
                        }}
                    ></SplitButton>
                }} />
            </BaseListagem>
        </>

    )
}
